import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Services } from "../../../api/Services";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { set } from "date-fns";

export const useProgramDetail = (id) => {
  const navigate = useNavigate();
  dayjs.locale("en");

  const today = dayjs();
  const cday = "" //localStorage.getItem("cday");
  const cweek = "" //localStorage.getItem("cweek");
  const dayOfWeek = ""//today.format("dddd");

  // State management
  const [reorder, setReorder] = useState(true);
  const [workouts, setWorkouts] = useState([]);
  const [pvalue, setPvalue] = useState("");
  const [programs, setPrograms] = useState([]);
  const [selectedworks, setSelectedworks] = useState([]);
  const [users, setUsers] = useState([]);
  const [isCopy, setIsCopy] = useState(false);
  const [groupList, setGrouplist] = useState([]);
  const [usersIds, setUsersIds] = useState([]);
  const [workIds, setWorkIds] = useState([]);
  const [groupId, setGroupId] = useState("");
  const [assign, setAssign] = useState("");
  const [show, setShow] = useState(false);
  const [selectedusers, setSelectedusers] = useState([]);
  const [userinput, setUserinput] = useState("");
  const [isLoading, setisLoading] = useState(false);
  const [isLoad, setisLoad] = useState(false);
  const [currentweek, setCurrentweek] = useState(cweek || null); // null by default
  const [currentDay, setCurrentDay] = useState(cday || dayOfWeek);
  const [order, setorder] = useState(0);
  const [isusers, setIsusers] = useState(false);
  const [weeks, setWeeks] = useState([]);
  const [isShow, setisShow] = useState(true);
  const [detail, setDetail] = useState([]);
  const [copyDetail, setCopyDetail] = useState([]);
  const [assigneDate, setAssignDate] = useState("");
  const [merge, setMerge] = useState(false);
  const [removeMerge, setRemoveMerge] = useState(false);
  const [selectedExerciseIds, setSelectedExerciseIds] = useState([]);
  const [selectedExerciseremoveIds, setSelectedExerciseremoveIds] = useState([]);
  const [selectWorkout, setSelectWorkout] = useState("");
  const [mvideo, setMvideo] = useState("");
  const [mergeId, setMergeId] = useState("");
  const [viewType, setViewType] = useState(localStorage.getItem("viewType") || "list");
  const [showModal, setShowModal] = useState(false);
  const [selectedWokrout, setSelectedWorkout] = useState(null);
  const [showProgramAttachmentModal, setShowProgramAttachmentModal] = useState(false);
  const [confirmActionModal, setConfirmActionModal] = useState(false);
  const [actionModalMessage, setActionModalMessage] = useState("");
  const [selectedActionObj, setSelectedActionObj] = useState(null);
  const [selectedActionObj2, setSelectedActionObj2] = useState(null);
  const [selectedActionObjType, setSelectedActionObjType] = useState(null);
  const [actionButtonTitle, setActionButtonTitle] = useState("Delete");

  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const formattedDate = `${year}-${month}-${day}`;

  // Set program id in localStorage
  useEffect(() => {
    localStorage.setItem("program_id", id);
  }, [id]);

  // API Functions
  const programmDetail = async (program_id, day, week) => {
    setisLoading(true);
    try {
      const result = await Services.getProgrammDetail(program_id, day, week);
      if (result.status === 200) {
        setDetail(result?.data?.data);
        setWorkouts(result?.data?.data?.workouts);
        const weekss = Array.from(
          { length: result?.data?.data?.number_of_weeks },
          (_, index) => index + 1
        );
        setWeeks(weekss);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setisLoading(false);
    } catch (error) {
      console.log(error);
      setisLoading(false);
    }
  };

  const getProgrammsLight = async () => {
    setisLoad(true);
    try {
      const result = await Services.getProgrammsListLight();
      if (result?.status == 200) {
        setPrograms(result?.data?.data);
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setisLoad(false);
    } catch (error) {
      console.log(error);
      setisLoad(false);
    }
  };

  const userGroups = async () => {
    try {
      const result = await Services.getUserGroups();
      if (result.status === 200) {
        setGrouplist(result?.data?.data?.listing);
      } else {
        toast.error("Some error", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Effects
  useEffect(() => {
    programmDetail(id, cday || currentDay, cweek || currentweek);
  }, [id, currentDay, currentweek, viewType, showProgramAttachmentModal]);

  useEffect(() => {
    if (viewType == "list") {
      getProgrammsLight();
      userGroups();
    }
  }, [viewType]);

  // Handler functions
  const setWeek = (week) => {
    setCurrentweek(week);
    localStorage.setItem("cweek", week);
  };

  const setDay = (day) => {
    setCurrentDay(day);
    localStorage.setItem("cday", day);
    setorder(0);
  };

  const formateSetsinputs = (sets) => {
    const uniqueValues = {};
    sets.forEach((set) => {
      set.inputs.forEach((input) => {
        const fieldName = input.field_name;
        const value = input.value;
        if (!uniqueValues[fieldName]) {
          uniqueValues[fieldName] = new Set();
        }
        uniqueValues[fieldName].add(value);
      });
    });

    const formattedValues = {};
    for (const fieldName in uniqueValues) {
      formattedValues[fieldName] = Array.from(uniqueValues[fieldName]);
    }
    return formattedValues;
  };

  return {
    // State
    id,
    reorder, setReorder,
    workouts, setWorkouts,
    pvalue, setPvalue,
    programs,
    selectedworks, setSelectedworks,
    users, setUsers,
    isCopy, setIsCopy,
    groupList,
    usersIds, setUsersIds,
    workIds, setWorkIds,
    groupId, setGroupId,
    assign, setAssign,
    show, setShow,
    selectedusers, setSelectedusers,
    userinput, setUserinput,
    isLoading,
    isLoad, setisLoad,
    currentweek,
    currentDay,
    order, setorder,
    isusers, setIsusers,
    weeks,
    isShow, setisShow,
    detail,
    copyDetail, setCopyDetail,
    assigneDate, setAssignDate,
    merge, setMerge,
    removeMerge, setRemoveMerge,
    selectedExerciseIds, setSelectedExerciseIds,
    selectedExerciseremoveIds, setSelectedExerciseremoveIds,
    selectWorkout, setSelectWorkout,
    mvideo, setMvideo,
    mergeId, setMergeId,
    viewType, setViewType,
    showModal, setShowModal,
    selectedWokrout, setSelectedWorkout,
    showProgramAttachmentModal, setShowProgramAttachmentModal,
    confirmActionModal, setConfirmActionModal,
    actionModalMessage, setActionModalMessage,
    selectedActionObj, setSelectedActionObj,
    selectedActionObj2, setSelectedActionObj2,
    selectedActionObjType, setSelectedActionObjType,
    actionButtonTitle, setActionButtonTitle,
    formattedDate,
    isFilterVisible: viewType === "list",
    
    // Functions
    programmDetail,
    setWeek,
    setDay,
    formateSetsinputs,
    navigate
  };
};
